"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

exports.__esModule = true;
exports.piraeus = exports.piraeusMatcher = exports.piraeusParser = exports.cleanString = exports.parseNumber = exports.generateYnabDate = void 0;

require("mdn-polyfills/String.prototype.startsWith");

var read_to_buffer_1 = require("../../util/read-to-buffer");

exports.generateYnabDate = function (input) {
  var match = input.match(/(\d{2})\/(\d{2})\/(\d{4})/);

  if (!match) {
    throw new Error('The input is not a valid date. Expected format: DD/MM/YYYY, got ' + input);
  }

  var day = match[1],
      month = match[2],
      year = match[3];
  return [month.padStart(2, '0'), day.padStart(2, '0'), year].join('/');
};

exports.parseNumber = function (input) {
  return Number(input.replace(',', '.'));
};

exports.cleanString = function (input) {
  return input.replace(/\s+/g, ' ').trim();
};

exports.piraeusParser = function (file) {
  return __awaiter(void 0, void 0, void 0, function () {
    var xlsx, workbook, _a, _b, sheet, rows, rowNum, category;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          return [4
          /*yield*/
          , Promise.resolve().then(function () {
            return __importStar(require('xlsx'));
          })];

        case 1:
          xlsx = _c.sent();
          _b = (_a = xlsx).read;
          return [4
          /*yield*/
          , read_to_buffer_1.readToBuffer(file)];

        case 2:
          workbook = _b.apply(_a, [_c.sent(), {
            type: 'buffer'
          }]);
          sheet = workbook.Sheets[workbook.SheetNames[0]];
          rows = [];

          for (rowNum = 5; true; rowNum++) {
            category = sheet["A" + rowNum];

            if (!category || category.t === 'e' || String(category.v).trim() === '') {
              break;
            }

            rows.push({
              Category: exports.cleanString(String(category.v)),
              Date: exports.generateYnabDate(String(sheet["C" + rowNum].v)),
              Memo: exports.cleanString(String(sheet["B" + rowNum].v).split('\r')[0]),
              Inflow: sheet["E" + rowNum].v > 0 ? sheet["E" + rowNum].v : undefined,
              Outflow: sheet["E" + rowNum].v < 0 ? -sheet["E" + rowNum].v : undefined
            });
          }

          return [2
          /*return*/
          , [{
            data: rows
          }]];
      }
    });
  });
};

exports.piraeusMatcher = function (file) {
  return __awaiter(void 0, void 0, void 0, function () {
    var xlsx, workbook, _a, _b, cell, e_1;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _c.trys.push([0, 3,, 4]);

          return [4
          /*yield*/
          , Promise.resolve().then(function () {
            return __importStar(require('xlsx'));
          })];

        case 1:
          xlsx = _c.sent();
          _b = (_a = xlsx).read;
          return [4
          /*yield*/
          , read_to_buffer_1.readToBuffer(file)];

        case 2:
          workbook = _b.apply(_a, [_c.sent(), {
            type: 'buffer'
          }]);
          cell = workbook.Sheets[workbook.SheetNames[0]]['A1'];
          return [2
          /*return*/
          , cell.v === 'Piraeus Bank'];

        case 3:
          e_1 = _c.sent();
          return [2
          /*return*/
          , false];

        case 4:
          return [2
          /*return*/
          ];
      }
    });
  });
};

exports.piraeus = {
  name: 'Piraeus Bank',
  country: 'gr',
  fileExtension: 'xlsx',
  filenamePattern: /Account Transactions_\d{8}\.xlsx/,
  link: 'https://www.piraeusbank.gr',
  match: exports.piraeusMatcher,
  parse: exports.piraeusParser
};